(() => {
  const makeWordWrapper = (word, index) => {
    const wrapper = document.createElement("span");
    wrapper.classList.add("hero-heading-animated");

    wrapper.style.cssText = [
      "display:inline-block",
      "font-style:inherit",
      "font-weight:inherit",
      "text-decoration:inherit",
      "color:inherit",
      "font-family:inherit",
      "line-height:inherit",
      "letter-spacing:inherit",
    ].join(";");
    //"white-space:nowrap",

    const inner = document.createElement("span");
    inner.textContent = word;
    inner.style.display = "inline-block";
    inner.style.animationDelay = `${index * 0.12}s`;

    wrapper.appendChild(inner);
    return wrapper;
  };

  const processTextNode = (textNode, startIndex = 0) => {
    const text = textNode.textContent;
    if (!text.trim())
      return { nodes: [document.createTextNode(text)], count: 0 };

    const parts = text.split(/(\s+)/);
    const out = [];
    let wordCount = 0;
    parts.forEach((part) => {
      if (part.match(/^\s+$/)) {
        out.push(document.createTextNode(part));
      } else {
        out.push(makeWordWrapper(part, startIndex + wordCount));
        wordCount++;
      }
    });

    return { nodes: out, count: wordCount };
  };

  const processElementNode = (el, wordIndexRef) => {
    const clone = el.cloneNode(false);
    if (el.attributes) {
      for (let i = 0; i < el.attributes.length; i++) {
        const a = el.attributes[i];
        clone.setAttribute(a.name, a.value);
      }
    }
    el.childNodes.forEach((child) => {
      if (child.nodeType === Node.TEXT_NODE) {
        const { nodes, count } = processTextNode(child, wordIndexRef.value);
        nodes.forEach((n) => clone.appendChild(n));
        wordIndexRef.value += count;
      } else if (child.nodeType === Node.ELEMENT_NODE) {
        const processed = processElementNode(child, wordIndexRef);
        clone.appendChild(processed);
      } else {
        clone.appendChild(child.cloneNode(true));
      }
    });
    return clone;
  };

  const initHeroHeadingAnimation = (section) => {
    if (!section || section.dataset.heroHeadingAnimation !== "true") return;

    const originalChildren = Array.from(section.childNodes);
    section.innerHTML = "";

    const wordIndexRef = { value: 0 };

    originalChildren.forEach((child) => {
      if (child.nodeType === Node.TEXT_NODE) {
        const { nodes } = processTextNode(child, wordIndexRef.value);
        nodes.forEach((n) => section.appendChild(n));
      } else if (child.nodeType === Node.ELEMENT_NODE) {
        const processed = processElementNode(child, wordIndexRef);
        section.appendChild(processed);
      } else {
        section.appendChild(child.cloneNode(true));
      }
    });

    const animatedWrappers = section.querySelectorAll(
      ".hero-heading-animated > span"
    );

    animatedWrappers.forEach((el, i) => {
      el.style.animationDelay = `${i * 0.12}s`;
    });

   

    const banner = section.closest(".media-banner__content");

    const otherContent = banner?.querySelector(".media-banner__details");

    const heroWrapper = section.closest(".media-banner--hero_heading_details");

    const heroSubheadings = heroWrapper?.querySelectorAll(
      ".media-banner__subheading"
    );

    heroSubheadings?.forEach((el) => {
      el.classList.add("subheading-hidden");
    });

    if (otherContent) {
      otherContent.classList.add("content-hidden");
    }


    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          entry.target.classList.add("in-view");

          const last = animatedWrappers[animatedWrappers.length - 1];

          if (last) {
            last.addEventListener(
              "animationend",
              () => {
                heroSubheadings?.forEach((el, i) => {
                  setTimeout(() => {
                    el.classList.add("subheading-visible");
                  }, i * 120);
                });

                setTimeout(() => {
                  if (otherContent) {
                    otherContent.classList.add("content-visible");
                  }
                }, 300);
              },
              { once: true }
            );
          }

          obs.unobserve(entry.target);
        });
      },
      { threshold: 0.3 }
    );

    observer.observe(section);
  };

  const initSections = (root = document) => {
    root
      .querySelectorAll(".media-banner--hero.richtext-link-inside")
      .forEach(initHeroHeadingAnimation);
  };

  initSections();
  document.addEventListener("shopify:section:load", (event) =>
    initSections(event.target)
  );

  const adjustHeroFontSize = () => {
    document
      .querySelectorAll(
        ".media-banner--hero.media-banner--hero--full_width.richtext-link-inside"
      )
      .forEach((heading) => {
        if (window.innerWidth >= 992) {
          const parentWidth = heading.parentElement.parentElement.offsetWidth;
          const padding = 20;
          const effectiveWidth = parentWidth - padding * 2;

          const minFontSize = 16;
          const maxFontSize = 1000;
          let fontSize = maxFontSize;

          //heading.style.whiteSpace = "nowrap";
          heading.style.display = "inline-block";
          heading.style.paddingLeft = padding + "px";
          heading.style.paddingRight = padding + "px";

          while (fontSize > minFontSize) {
            heading.style.fontSize = fontSize + "px";
            const textWidth =
              heading.getBoundingClientRect().width - padding * 2;

            if (textWidth <= effectiveWidth) break;
            fontSize -= 1;
          }

          heading.style.fontSize = Math.max(fontSize, minFontSize) + "px";
        }
      });
  };

  window.addEventListener("resize", adjustHeroFontSize);
  document.addEventListener("DOMContentLoaded", adjustHeroFontSize);
  document.addEventListener("shopify:section:load", adjustHeroFontSize);
})();
